import { Alert, AlertTitle } from '@material-ui/lab';
import React from 'react';
import Link from '@material-ui/core/Link';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { markNotificationAsRead, removeNotificationAlertAction } from '../../reducers/auth';
import { useSelector } from 'react-redux';

const PatientCaseAlert = ({ id, patientName, patientId, title }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const isManagement = useSelector(state => state.auth.isManagement);

  const handleAlertClose = () => {
    dispatch(removeNotificationAlertAction(id));
    dispatch(markNotificationAsRead(id));
  };

  const handleLinkClick = e => {
    e.preventDefault();

    const redirect = isManagement ? `/patient-workflow/${patientId}` : `/patient-details/${patientId}`;
    history.push(redirect);
  };

  return (
    <Alert severity="info" key={id} onClose={handleAlertClose}>
      <AlertTitle>{title}</AlertTitle>
      <Link href="#" onClick={handleLinkClick}>
        Patient: {patientName}
      </Link>
    </Alert>
  );
};

PatientCaseAlert.propTypes = {
  id: PropTypes.string.isRequired,
  patientName: PropTypes.string.isRequired,
  patientId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired
};

export default PatientCaseAlert;
